/*
 * @desc 统一管理所有的定值
 */

let constants = {}

constants.basic = {
  version: '2.0',
  apiBaseUrl: '',
  siteName: '鑫聚鹏后台管理系统',
  shortSiteName: '鑫聚鹏',
  companyName: '快鱼IT',
  domain: process.env.DOMAIN,
  domain_pic: process.env.DOMAIN_PIC
}

export default constants



// WEBPACK FOOTER //
// ./src/config/constants.js